<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main" >
			<div class="subject">
				<el-row type="flex" class="subject_title">
					<img src="@/assets/img/tag.png" alt="">
					<span class="title_text">基本信息</span>
				</el-row>

				<el-descriptions class="margin-top" border labelClassName="labelWidth" contentClassName="contentStyle">
					<el-descriptions-item label="可疑情况序号">{{ list.kyqkdjxh }}</el-descriptions-item>
					<el-descriptions-item label="场所编号">{{ list.cs_dmsn }}</el-descriptions-item>
					<el-descriptions-item label="可疑类型">{{ list.kyqklxdm | kylxFilter }}</el-descriptions-item>
					<!--  -->
					<el-descriptions-item label="填报人姓名"> {{ list.djrxm }}</el-descriptions-item>
					<el-descriptions-item label="填报人电话"> {{ list.djrdh }}</el-descriptions-item>
					<el-descriptions-item label="填报时间"> {{ list.create_time }}</el-descriptions-item>
					<!--  -->
					<el-descriptions-item label="疑点详情描述" span="2"> {{ list.kyqk_jyms }}</el-descriptions-item>
					<el-descriptions-item label="处理结果" span="2"> {{ list.handle_status | jqclFilter }}</el-descriptions-item>
					<!--  -->
				</el-descriptions>


			</div>
			<div class="subject_btn" style="text-align:center;margin-top: 56px;">
				<!-- <el-button type="info" @click="goBack">返回</el-button>  2020-06-02 产品去掉-->
				<el-button type="primary" @click="$router.back(-1)" class="go_back">返回</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
import { getkyqkitem } from '@/api/day_work.js'
import { lists, filtersInfo } from '@/utils/dictionary.js'
let that
export default {
	name: 'EmployeesDetailsVue',
	data() {
		return {
			breadcrumbList: [
				{ name: "可疑情况", path: "suspicious" },
				{ name: "详情", path: "suspicious/suspicious_details" }
			],
			list: [],
			kylxList: [],
			loading: true
		}
	},
	beforeCreate() {
		that = this
	},
	created() {
		this.info()
	},
	methods: {
		async info() {
			this.id = this.$route.query.id
			this.list = await getkyqkitem(this.id)
			this.kylxList = lists['KYLX']
			
		}
	},
	filters: {
		kylxFilter(val) {
			if (!val && val != 0) return
			return filtersInfo(that.kylxList, val)
		},
		jqclFilter(val) {
			if (!val && val != 0) return
			if (val == '0') {
				return '未处理'
			} else {
				return '已处理'
			}
		},
	}
}
</script>

<style lang="less" scoped>
.main {
	margin: 20px;
	padding: 22px 20px;

	.subject {
		.subject_title {
			margin-bottom: 23px;

			img {
				width: 30px;
				height: 39px;
				margin-right: 3px;
			}

			.title_text {
				font-size: 18px;
				line-height: 36px;
				font-family: Source Han Sans SC;
				font-weight: bold;
				color: #6345D5;
			}
		}
	}

	/deep/ .labelWidth {
		width: 150px;
	}

	/deep/ .contentStyle {
		width: 18vw;
	}

	.go_back {
		width: 80px;
		height: 50px;
		background: #FFFFFF;
		border: 1px solid #6345D5;
		border-radius: 6px;
		color: #6345D5;
	}
}
</style>
